interface IGetPhoneButtonTextParams {
  isDealRent: boolean;
  isNewbuildingFromBuilder: boolean;
  isNewbuildingFromSeller: boolean;
  isSuburbanFromBuilder: boolean;
}

export const getPhoneButtonText = ({
  isDealRent,
  isNewbuildingFromBuilder,
  isNewbuildingFromSeller,
  isSuburbanFromBuilder,
}: IGetPhoneButtonTextParams): string => {
  if (isDealRent) {
    return 'Назначить просмотр';
  }

  if (isNewbuildingFromBuilder || isSuburbanFromBuilder) {
    return 'Контакты застройщика';
  }

  if (isNewbuildingFromSeller) {
    return 'Контакты продавца';
  }

  return 'Показать телефон';
};
